// ./src/components/lists/ListUserProviders/Item/index.tsx
import React, { useState } from 'react';

import { BsPersonCheckFill } from 'react-icons/bs';
import { FaRobot } from 'react-icons/fa';
import {
  IoEllipsisHorizontal,
  IoEllipse,
  IoCreate,
  IoTrash,
} from 'react-icons/io5';

import { Paragraph } from '@components/index';
import { ConfigStyles, ConfigTransition, ConfigValues } from '@config/index';
import User from '@models/User';
import { formatMoney, formatText } from '@utils/formatters';

import {
  Container,
  CompositeItem,
  CompositeItemText,
  Dropdown,
  DropdownItem,
  DropdownButton,
} from './styles';

interface IProps {
  distanceInKm: number | undefined;
  handleConfirmProvider(provider: User): void;
  user: User;
}

const ListProvidersItem: React.FC<IProps> = ({
  user,
  distanceInKm,
  handleConfirmProvider,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [
    firstAddressNeighborhood,
    secondAddressNeighborhood,
  ] = user.adresses[0].neighborhood.split(' ');
  return (
    <Container onClick={() => setIsExpanded(prevState => !prevState)}>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {user.name.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {user.cellphone}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {`${formatText.capitalizedFirstLetter(
          firstAddressNeighborhood,
        )} ${formatText.capitalizedFirstLetter(secondAddressNeighborhood)}`}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        0
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {distanceInKm} KMs
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {formatMoney.fromNumberToPrice(0)}
      </Paragraph>
      <Paragraph nameColor="black" className="btn-options">
        <IoEllipsisHorizontal
          size={16}
          color={ConfigStyles.rebox.colors.black.main}
          style={{ cursor: 'pointer' }}
        />
      </Paragraph>
      <Dropdown expande={isExpanded}>
        <DropdownItem to={``} style={{ cursor: 'not-allowed', opacity: 0.5 }}>
          <FaRobot
            size={16}
            title="ícone de editar"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Enviar automação
          </Paragraph>
        </DropdownItem>
        <DropdownItem to={``} style={{ cursor: 'not-allowed', opacity: 0.5 }}>
          <IoCreate
            size={16}
            title="ícone de editar"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Enviar manualmente
          </Paragraph>
        </DropdownItem>

        <DropdownButton onClick={() => handleConfirmProvider(user)}>
          <BsPersonCheckFill
            size={16}
            title="ícone de lixeira"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Confirmar prestador
          </Paragraph>
        </DropdownButton>
      </Dropdown>
    </Container>
  );
};

export default ListProvidersItem;
